<template>
  <v-container fluid>
    <v-expansion-panel v-model="panel" expand popout v-if="links && links.length">
      <v-expansion-panel-content v-for="(link,index) in links" :key="index">
        <template v-slot:header>
          <v-layout row wrap>
            <v-flex xs12 class="caption grey--text">
              {{
              moment.utc(link.created_at).local().fromNow()
              }}
            </v-flex>
            <v-flex xs12 class="subheading text-truncate">{{ link.created_for_email }}</v-flex>
          </v-layout>
        </template>
        <v-card>
          <v-card-title class="pt-0 mx-2">
            <div>
              {{$t('rms_expired_at_label')}} &mdash;
              {{ moment(link.expiry_date).format('lll') }}
            </div>
          </v-card-title>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <NotFound v-else></NotFound>
    <!-- Edit dialog box -->
    <Edit
      v-model="dialog"
      :dialog="dialog"
      :link="selected_link"
      :timeLimits="timeLimits"
      v-if="dialog"
    ></Edit>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Edit from "@/components/invitation/Edit";
import NotFound from "@/components/NotFound";

export default {
  name: "ExpiredLinks",
  data() {
    return {
      panel: [true],
      dialog: false,
      selected_link: null
    };
  },
  computed: {
    ...mapGetters({
      links: "avails/getExpiredLinks",
      selected_company_id: "company/getSelected"
    }),
    timeLimits() {
      return this.DEFINES.TIME_LIMITS;
    }
  },
  components: {
    Edit,
    NotFound
  }
};
</script>

<style>
</style>


